export default __webpack_public_path__ + "static/media/profile-billing-icon.26fe8f71.svg";